import { useEffect } from 'react'
import { Map } from 'immutable'
import _get from 'lodash/get'
import _map from 'lodash/map'
import _parseInt from 'lodash/parseInt'
import _split from 'lodash/split'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { useMutation } from '@apollo/client'
import { getBoundActions } from '../../actions/index'
import { URL_HOME, URL_PLAYLIST_WATCH_LATER } from '../../services/url/constants'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { TYPE_CONTENT_VIDEO } from '../../services/content-type/index'
import { PLAYLIST_TYPE_DEFAULT } from '../../services/playlist/index'
import { ADD_TO_PLAYLIST } from '../../services/playlist/query'
import { handleRedirect } from './utils'

function GoAddToPlaylist (props) {
  const {
    setOverlayDialogVisible,
    staticText,
    addToasty,
    location,
    history,
    authJwt,
    user,
    auth,
  } = props

  const isLoggedIn = getAuthIsLoggedIn(auth)
  const playlistAdd = _get(location, ['query', 'playlistAdd'])
  const redirectTo = _get(location, ['query', 'url'])
  const contentIds = _map(_split(playlistAdd, ','), _parseInt)

  const [
    addToPlaylist,
    { error: addToPlaylistError },
  ] = useMutation(ADD_TO_PLAYLIST, {
    onQueryUpdated: (observableQuery) => {
      return observableQuery.refetch()
    },
    context: {
      jwt: authJwt,
    },
  })

  const handleAddToPlaylist = async () => {
    if (contentIds && contentIds.length > 0) {
      const promises = contentIds.map((contentId) => addToPlaylist({
        variables: {
          contentId,
          contentType: TYPE_CONTENT_VIDEO,
          playlistType: PLAYLIST_TYPE_DEFAULT,
        },
      }))
      const results = await Promise.all(promises)

      if (addToPlaylistError) {
        addToasty(staticText.get('addToPlaylistError'))
      } else {
        results.forEach((result) => {
          const item = _get(result, ['data', 'playlistCreatePlaylistItem', 'playlistItem'], {})
          const contentTitle = _get(item, ['content', 0, 'title'])
          addToasty(`${contentTitle} ${staticText.get('addedToYourPlaylist')}`)
        })

        handleRedirect({
          history,
          auth,
          user,
          url: redirectTo || URL_PLAYLIST_WATCH_LATER,
        })
      }
    } else {
      handleRedirect({
        history,
        auth,
        user,
        url: URL_HOME,
      })
    }
  }

  useEffect(() => {
    if (!isLoggedIn) {
      setOverlayDialogVisible(TYPE_LOGIN)
    } else {
      handleAddToPlaylist()
    }
  }, [isLoggedIn])

  return null
}

GoAddToPlaylist.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addToasty: PropTypes.func.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
  authJwt: state.auth.get('jwt'),
  staticText: state.staticText.getIn(['data', 'goPage', 'data'], Map()) || Map(),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    addToasty: actions.toasty.addToasty,
    setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
  }
})(GoAddToPlaylist)
